export default theme => ({
  root: {
    width: "100%",
    height: "auto",
    textAlign: "left",
  },
  statusText: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  contractContainer: {
    width: "100%",
  },
  signatureContainer: {
    marginTop: theme.spacing(5),
  },
  signatureBox: {
    border: "1px solid #bdbdbd",
    borderRadius: "6px",
    padding: theme.spacing(2.5),
    maxWidth: "560px",
    backgroundColor: "#fff",
  },
  signatureRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
    "&:last-child": {
      marginBottom: 0,
    },
  },
  signatureLabel: {
    minWidth: "180px",
    fontWeight: 500,
  },
  signatureValueLine: {
    flex: 1,
    borderBottom: "1px solid #616161",
    minHeight: "24px",
    display: "flex",
    alignItems: "flex-end",
    padding: "0 4px 2px",
  },
});
